import * as React from 'react'
import {
  IAutoComplete,
  IUserTrips,
  ILocationV2,
  IRiderLocationObject,
  IRiderObject,
  IStateMetadata,
  ILocationStopV2
} from '../../../types'
import {
  SET_ADDITIONAL_STOP_TO_TRIP_REQUEST,
  SET_DESTINATION_TO_TRIP_REQUEST,
  SET_ORIGIN_TO_TRIP_REQUEST
} from '../../../state/constants'
import { IGoogleMapBoundsDTO } from '../../../types/google-map'
import { LocationTypes } from '../../../constants/trip'
import Point from '../../icons/ui/Point'
import SearchTripListResult from './SearchTripListResult'
import PinLocationModal from '../../PinLocationModal'
import EditIcon from 'src/components/icons/ui/Edit'
import ToolTip from 'src/components/ui/ToolTip'
import PlusSignIcon from 'src/components/icons/ui/PlusSignIcon'
import TrashBlueIcon from 'src/components/icons/ui/TrashBlueIcon'
import PlusSignIconGray from 'src/components/icons/ui/PlusSignIconGray'
import DragIndicator from 'src/components/icons/ui/DragIndicator'
import Swap from 'src/components/icons/ui/Swap'

interface ILocationSearchProps {
  riderId: string
  rider: IRiderObject
  polygon: any
  pickupAutoComplete: IAutoComplete[]
  dropoffAutoComplete: IAutoComplete[]
  additionalStopAutoComplete: IAutoComplete[]
  recentTrips: IUserTrips[]
  favoriteTrips: IUserTrips[]
  pickup: ILocationV2
  dropoff: ILocationV2
  additionalStop: ILocationStopV2[]
  details: any
  zoom: number
  bounds: IGoogleMapBoundsDTO
  metadata: IStateMetadata
  locations: IRiderLocationObject[]
  swapLocations: (params: { pickup?: ILocationV2; dropoff: ILocationV2 }) => Promise<any>
  showPickupAutoComplete: (e: any) => Promise<any>
  showDropoffAutoComplete: (e: any) => Promise<any>
  showAdditionalStopComplete: (e: any, index: number) => Promise<any>
  clearAutoComplete: () => Promise<any>
  clearLocationSearch: () => Promise<any>
  clearMap: () => Promise<any>
  selectPickup: (e: any) => Promise<any>
  selectDropoff: (e: any) => Promise<any>
  selectAdditionalStop: (e: any) => Promise<any>
  changeAdditionalStopOrder: (draggedIndex: number, draggedOverIndex: number) => Promise<any>
  changeLocationsOrder: (draggedIndex: number, draggedOverIndex: number) => Promise<any>
  removeAdditionalStop: (e: any) => Promise<any>
  getRiderLocationList: (riderId: string) => void
  openModal: (locationType: string) => void
  saveLocation: (
    riderId: string,
    location: IRiderLocationObject,
    locationType: string,
    locations: IRiderLocationObject[],
    index?: number
  ) => void
  setRiderLocationQuery: (query: string) => void
  setDropoffPhoneNumber: (phone: string) => void
  setPickupPhoneNumber: (phone: string) => void
  setTripReqDetails: (payload: any) => void
}

interface ILocationSearchState {
  enableAdditionalStop: boolean
  isOpen: boolean
  showPickupAutcomplete: boolean
  showDropoffAutocomplete: boolean
  showAdditionalStopAutoComplete: boolean
  additionalStopAutocompleteToShow: number
  locationType: string
  pickup: ILocationV2
  dropoff: ILocationV2
  additionalStopInputValue: string
  additionalStop: ILocationStopV2[]
  additionalStopsIndeces: number[]
  selectedAdditionalStopForPinLocation: number
  draggedItem: ILocationV2 | ILocationStopV2 | null
}

interface ILocationSearchInputState {
  value: string
}

interface IILocationSearchInputProps {
  placeholder: string
  onClear: () => void
  showAutoComplete: (e: any) => void
  onFocus: (e: any) => void
  name: string
  value?: string
}

class LocationSearchInput extends React.Component<IILocationSearchInputProps, ILocationSearchInputState> {
  constructor(props: IILocationSearchInputProps) {
    super(props)
    this.state = {
      value: this.props.value || ''
    }
  }
  public componentDidMount() {
    this.state = {
      value: this.props.value || ''
    }
  }

  public render() {
    return (
      <React.Fragment>
        <input
          className='ls-location-input'
          placeholder={this.props.placeholder}
          type='text'
          onFocus={this.props.onFocus}
          onChange={this.onChange}
          name={this.props.name}
          value={this.state.value}
          autoComplete='off'
        />
      </React.Fragment>
    )
  }

  public componentDidUpdate(oldProps: IILocationSearchInputProps) {
    const newProps = this.props
    if (newProps.value && oldProps.value !== newProps.value) {
      this.setState({ value: newProps.value })
    }
  }

  private onChange = (e: any) => {
    this.setState({ value: e.target.value })
    this.props.showAutoComplete(e)
  }
}

class LocationSearch extends React.Component<ILocationSearchProps, ILocationSearchState> {
  public wrapperRef: any
  constructor(props: ILocationSearchProps) {
    super(props)
    const indeces = props.additionalStop.filter(stop => stop.index !== undefined).map(stop => stop.index)

    if (indeces !== undefined && indeces.length > 0) {
      this.setState({
        additionalStopsIndeces: indeces as number[]
      })
    }
    this.state = {
      isOpen: false,
      showPickupAutcomplete: false,
      showDropoffAutocomplete: false,
      showAdditionalStopAutoComplete: false,
      locationType: '',
      pickup: props.pickup as ILocationV2,
      dropoff: props.dropoff as ILocationV2,
      enableAdditionalStop: false,
      additionalStopInputValue: '',
      additionalStop: props.additionalStop as ILocationStopV2[],
      additionalStopsIndeces: indeces !== undefined ? (indeces as number[]) : [],
      additionalStopAutocompleteToShow: -1,
      selectedAdditionalStopForPinLocation: -1,
      draggedItem: null
    }
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  public componentDidMount() {
    this.props.getRiderLocationList(this.props.riderId)
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  public componentWillUnmount() {
    this.props.clearLocationSearch()
    this.props.clearMap()
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  public render() {
    const {
      additionalStop,
      additionalStopAutoComplete,
      dropoff,
      dropoffAutoComplete,
      locations,
      pickup,
      pickupAutoComplete
    } = this.props
    let location = this.state.locationType === LocationTypes.PICKUP ? this.state.pickup : this.state.dropoff
    if (this.state.locationType === LocationTypes.PICKUP) {
      location = this.state.pickup
    } else if (this.state.locationType === LocationTypes.DROPOFF) {
      location = this.state.dropoff
    } else {
      if (additionalStop !== undefined && this.state.additionalStop !== undefined) {
        const selectedStopLocation = this.state.additionalStop.find(
          stop => stop.index === this.state.selectedAdditionalStopForPinLocation
        )
        if (selectedStopLocation !== undefined) {
          location = selectedStopLocation as ILocationV2
        }
      }
    }
    let foundRiderLocation = locations.find(
      (rl: IRiderLocationObject) =>
        rl.coordinates.lat === location.latitude && rl.coordinates.lng === location.longitude
    )
    if (!foundRiderLocation) {
      foundRiderLocation = {
        coordinates: { lat: location.latitude, lng: location.longitude },
        fullAddress: location.fullAddress,
        note: location.notes ? location.notes : ''
      } as IRiderLocationObject
    }

    const addStop = () => {
      let largest = 0
      const array = this.state.additionalStopsIndeces !== undefined ? [...this.state.additionalStopsIndeces] : []

      if (array.length > 0) {
        largest = array.sort((a, b) => a - b)[array.length - 1]

        const additionalStopsIndeces = [...array, largest + 1]
        this.setState({
          additionalStopsIndeces
        })
      } else {
        this.setState({
          additionalStop: []
        })
        setTimeout(
          () =>
            this.setState({
              additionalStopsIndeces: [0]
            }),
          250
        )
      }
    }

    const deleteStop = (index: number) => {
      const indecesArray = this.state.additionalStopsIndeces.filter(stop => stop !== index)
      const stopsArray = this.state.additionalStop.filter(stop => stop.index !== index)

      this.setState({
        additionalStopsIndeces: indecesArray,
        additionalStop: stopsArray
      })
      this.props.removeAdditionalStop(index)
      this.props.setRiderLocationQuery('')
    }

    const checkIfStopHasValue = (index: number) => {
      if (additionalStop !== undefined) {
        const stop = additionalStop.find(stop => stop.index === index)
        if (stop !== undefined) {
          return stop.fullAddress ? true : false
        } else {
          return false
        }
      } else {
        return false
      }
    }

    const getAdditionalStopNote = (index: number) => {
      if (additionalStop !== undefined) {
        const stop = additionalStop.find(stop => stop.index === index)
        if (stop !== undefined) {
          return stop.notes ? stop.notes : undefined
        } else {
          return undefined
        }
      } else {
        return undefined
      }
    }

    const getAdditionalStopValue = (index: number) => {
      if (additionalStop !== undefined) {
        const stop = additionalStop.find(stop => stop.index === index)
        if (stop !== undefined) {
          return stop.fullAddress ? stop.fullAddress : undefined
        } else {
          return undefined
        }
      } else {
        return undefined
      }
    }

    const checkIfLastStopHasLocation = () => {
      const array = [...this.state.additionalStopsIndeces]
      const largest = array.sort((a, b) => a - b)[array.length - 1]
      if (largest === undefined) {
        return true
      } else {
        if (additionalStop !== undefined) {
          const array = [...this.state.additionalStopsIndeces]
          const largest = array.sort((a, b) => a - b)[array.length - 1]
          const stop = additionalStop.find(stop => stop.index === largest)
          if (stop !== undefined) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    }

    const onDragStart = (event: React.DragEvent<HTMLSpanElement>, index: number) => {
      const parentElement = event.currentTarget.parentElement
      const parentNode = event.currentTarget.parentNode ? event.currentTarget.parentNode.parentElement : null

      if (!parentElement || !parentNode) {
        return
      } else {
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('text/html', parentElement.outerHTML)
        event.dataTransfer.setDragImage(parentNode, parentNode.clientWidth * 2 - 50, parentNode.clientHeight)
      }

      let draggedItem

      if (index === -1) {
        draggedItem = this.state.pickup
      } else if (index === -2) {
        draggedItem = this.state.dropoff
      } else {
        const draggedStop: ILocationStopV2 = this.state.additionalStop.find(
          stop => stop.index === index
        ) as ILocationStopV2
        draggedItem = draggedStop
      }

      if (index === -1 || index === -2) {
        this.setState({
          draggedItem: {
            ...draggedItem,
            index
          }
        })
      } else {
        this.setState({
          draggedItem
        })
      }
    }

    const onDrop = (index: number) => {
      const draggedItemIndex =
        this.state.draggedItem !== null && this.state.draggedItem !== undefined
          ? this.state.draggedItem.index !== undefined
            ? this.state.draggedItem.index
            : -3
          : -3
      if (((index === -1 && draggedItemIndex) || (index === -2 && draggedItemIndex)) && additionalStop.length === 0) {
        this.clickSwap(index)
      } else if (index >= 0 && draggedItemIndex >= 0 && index !== draggedItemIndex) {
        this.swapStops(index)
      } else {
        this.swapLocations(index)
      }
    }

    return (
      <React.Fragment>
        <div ref={this.setWrapperRef} className='fit py2 px1'>
          {this.state.isOpen && (
            <PinLocationModal
              locationType={this.state.locationType}
              zoom={this.props.zoom}
              bounds={this.props.bounds}
              location={foundRiderLocation}
              locations={locations}
              metadata={this.props.metadata}
              onCancel={this.onCancel}
              saveLocation={this.onSaveLocation}
              updateLocation={this.updateLocation}
            />
          )}
          <div className='column-gap-16 flex items-center'>
            <div className='mbsc-flex-1-1'>
              <div
                className='ls-location-item'
                onDragOver={(event: any) => event.preventDefault()}
                onDrop={() => onDrop(-1)}
              >
                <Point className='svg-green' />
                <div className='ls-location-input-container'>
                  <LocationSearchInput
                    placeholder='Choose pickup point'
                    onClear={this.props.clearAutoComplete}
                    showAutoComplete={this.showPickupAutoComplete}
                    onFocus={this.onFocus}
                    name={LocationTypes.PICKUP}
                    value={pickup ? pickup.fullAddress : ''}
                  />
                  {this.state.showPickupAutcomplete &&
                    ((locations && locations.length > 0) || (pickupAutoComplete && pickupAutoComplete.length > 0)) && (
                      <SearchTripListResult
                        recentTrips={[]}
                        googleLocs={this.props.pickupAutoComplete}
                        riderLocations={locations}
                        favoriteTrips={[]}
                        onChoose={this.selectPickup}
                      />
                    )}
                </div>
                {pickup.fullAddress && (
                  <div className='flex'>
                    <span className='ls-location-item-edit' onClick={this.openPickUpModal}>
                      <EditIcon className='icon--small svg-blue cursor--pointer' />
                    </span>
                    <span
                      draggable={true}
                      className='ml1'
                      onDragStart={(event: React.DragEvent<HTMLSpanElement>) => onDragStart(event, -1)}
                    >
                      <DragIndicator className='icon--small svg-blue cursor--pointer' />
                    </span>
                  </div>
                )}
              </div>
              <div className='ml3 mb1 pickup-note text-start'>{pickup.notes ? `pickup note: ${pickup.notes}` : ''}</div>
              {this.state.additionalStopsIndeces !== undefined &&
                this.state.additionalStopsIndeces.map((value, index, array) => {
                  return (
                    <>
                      <div
                        className='ls-location-item'
                        key={value}
                        onDragOver={(event: React.DragEvent<HTMLDivElement>) => event.preventDefault()}
                        onDrop={() => onDrop(value)}
                      >
                        <Point className='svg-blue' />
                        <div className='ls-location-input-container'>
                          <LocationSearchInput
                            placeholder='Choose additional stop'
                            onClear={this.props.clearAutoComplete}
                            showAutoComplete={e => this.showAdditionalStopAutoComplete(e, value)}
                            onFocus={e => this.onFocus(e, value)}
                            name={LocationTypes.ADDITIONALSTOP + value}
                            value={getAdditionalStopValue(value) !== undefined ? getAdditionalStopValue(value) : ''}
                          />
                          {this.state.additionalStopAutocompleteToShow === value &&
                            ((locations && locations.length > 0) ||
                              (additionalStopAutoComplete && additionalStopAutoComplete.length > 0)) && (
                              <SearchTripListResult
                                recentTrips={[]}
                                googleLocs={additionalStopAutoComplete}
                                riderLocations={locations}
                                favoriteTrips={[]}
                                onChoose={(location: any) => this.selectStop(location, value)}
                              />
                            )}
                        </div>
                        <span
                          className='ls-location-item-delete'
                          onClick={() => deleteStop(value)}
                          style={{ maxHeight: '20px', paddingRight: '4px' }}
                        >
                          <TrashBlueIcon className='svg-blue cursor--pointer' />
                        </span>
                        {checkIfStopHasValue(value) && (
                          <div className='flex'>
                            <span className='ls-location-item-edit' onClick={() => this.openStopModal(value)}>
                              <EditIcon className='icon--small svg-blue cursor--pointer' />
                            </span>
                            <span
                              draggable={true}
                              className='ml1'
                              onDragStart={(event: React.DragEvent<HTMLSpanElement>) => onDragStart(event, value)}
                            >
                              <DragIndicator className='icon--small svg-blue cursor--pointer' />
                            </span>
                          </div>
                        )}
                      </div>
                      <div className='ml3 mb1 pickup-note text-start'>
                        {getAdditionalStopNote(value) !== undefined ? `stop note: ${getAdditionalStopNote(value)}` : ''}
                      </div>
                    </>
                  )
                })}
              <div
                className='ls-location-item'
                onDragOver={(event: any) => event.preventDefault()}
                onDrop={() => onDrop(-2)}
              >
                <Point className='svg-red' />
                <div className='ls-location-input-container'>
                  <LocationSearchInput
                    placeholder='Choose dropoff point'
                    onClear={this.props.clearAutoComplete}
                    showAutoComplete={this.showDropoffAutoComplete}
                    onFocus={this.onFocus}
                    name={LocationTypes.DROPOFF}
                    value={dropoff ? dropoff.fullAddress : ''}
                  />
                  {this.state.showDropoffAutocomplete &&
                    ((locations && locations.length > 0) ||
                      (dropoffAutoComplete && dropoffAutoComplete.length > 0)) && (
                      <SearchTripListResult
                        recentTrips={[]}
                        googleLocs={this.props.dropoffAutoComplete}
                        riderLocations={locations}
                        favoriteTrips={[]}
                        onChoose={this.selectDropoff}
                      />
                    )}
                </div>
                {dropoff.fullAddress && (
                  <div className='flex'>
                    <span className='ls-location-item-edit' onClick={this.openDropOffModal}>
                      <EditIcon className='icon--small svg-blue cursor--pointer' />
                    </span>
                    <span
                      draggable={true}
                      className='ml1'
                      onDragStart={(event: React.DragEvent<HTMLSpanElement>) => onDragStart(event, -2)}
                    >
                      <DragIndicator className='icon--small svg-blue cursor--pointer' />
                    </span>
                  </div>
                )}
              </div>
            </div>
            {pickup.fullAddress && dropoff.fullAddress && (
              <div>
                <Swap onClick={this.clickSwap} />
              </div>
            )}
          </div>
          <div className='ml3 my1 pickup-note text-start'>{dropoff.notes ? `dropoff note: ${dropoff.notes}` : ''}</div>
          {this.state.additionalStopsIndeces.length < 5 && checkIfLastStopHasLocation() ? (
            <div onClick={addStop} style={{ maxHeight: '15px', marginLeft: '4px' }}>
              <div className='flex items-center'>
                <PlusSignIcon className='svg-blue' />
                <span className='ls-add-stop-button'>Add Stop</span>
              </div>
            </div>
          ) : (
            <div style={{ maxHeight: '15px', marginLeft: '4px' }}>
              {this.state.additionalStopsIndeces.length === 5 ? (
                <div className='flex items-center'>
                  <PlusSignIconGray className='svg-grey' />
                  <span className='ls-add-stop-button-disabled'>Max Stops Reached</span>
                </div>
              ) : (
                <div className='flex items-center'>
                  <PlusSignIconGray className='svg-grey' />
                  <span className='ls-add-stop-button-disabled'>Add Stop</span>
                </div>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }
  private setWrapperRef(node: any) {
    this.wrapperRef = node
  }

  private handleClickOutside(event: any) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        additionalStopAutocompleteToShow: -1,
        showDropoffAutocomplete: false,
        showPickupAutcomplete: false
      })
    }
  }

  private updateLocation = (loc: any) => {
    const { locationType, selectedAdditionalStopForPinLocation } = this.state
    if (locationType === LocationTypes.PICKUP) {
      this.setState({ pickup: loc })
    } else if (locationType === LocationTypes.DROPOFF) {
      this.setState({ dropoff: loc })
    } else {
      const updatedStop = {
        ...loc,
        index: selectedAdditionalStopForPinLocation
      }

      const filteredStops = this.state.additionalStop.filter(
        stop => stop.index !== selectedAdditionalStopForPinLocation
      )
      const updatedStops = [...filteredStops, updatedStop].sort((a, b) => (a.index as number) - (b.index as number))
      this.setState({ additionalStop: updatedStops })
    }
  }

  private showPickupAutoComplete = (e: any) => {
    this.props.setRiderLocationQuery(e.target.value)
    if (!e.target.value) {
      this.props.clearAutoComplete()
      return
    }
    this.props.showPickupAutoComplete(e)
  }

  private showDropoffAutoComplete = (e: any) => {
    this.props.setRiderLocationQuery(e.target.value)
    if (!e.target.value) {
      this.props.clearAutoComplete()
      return
    }

    this.props.showDropoffAutoComplete(e)
  }

  private showAdditionalStopAutoComplete = (e: any, index: number) => {
    this.props.setRiderLocationQuery(e.target.value)
    if (!e.target.value) {
      this.props.clearAutoComplete()
      return
    }

    this.props.showAdditionalStopComplete(e, index)
  }

  private onFocus = (e: any, index?: number) => {
    this.props.setRiderLocationQuery(e.target.value)
    const { name } = e.target

    if (name === LocationTypes.ADDITIONALSTOP + index) {
      if (index !== undefined) {
        this.setState({
          additionalStopAutocompleteToShow: index
        })
      }
    } else {
      this.setState({
        showPickupAutcomplete: name === LocationTypes.PICKUP ? true : false,
        showDropoffAutocomplete: name === LocationTypes.DROPOFF ? true : false,
        additionalStopAutocompleteToShow: -1
      })
    }
  }

  private selectPickup = (location: any) => {
    this.setState({
      showPickupAutcomplete: false,
      pickup: location
    })
    this.props.selectPickup(location)
    this.props.setRiderLocationQuery('')
  }

  private selectStop = (location: any, index: number) => {
    const selectedStop = this.state.additionalStop.find(value => value.index === index)

    if (selectedStop !== undefined) {
      const updatedStop = {
        ...location,
        index: selectedStop.index
      }

      const filteredStops = this.state.additionalStop.filter(stop => stop.index !== index)
      const updatedStops = [...filteredStops, updatedStop].sort((a, b) => a.index - b.index)

      this.setState({
        additionalStopAutocompleteToShow: -1,
        additionalStop: updatedStops
      })
      this.props.selectAdditionalStop(updatedStop)
      this.props.setRiderLocationQuery('')
    } else {
      const newStop = {
        ...location,
        index
      }
      const additionalStop = [...this.state.additionalStop, newStop].sort((a, b) => a.index - b.index)

      this.setState({
        additionalStopAutocompleteToShow: -1,
        additionalStop
      })

      this.props.selectAdditionalStop(newStop)
      this.props.setRiderLocationQuery('')
    }
  }

  private selectDropoff = (location: any) => {
    this.setState({
      showDropoffAutocomplete: false,
      dropoff: location
    })
    this.props.selectDropoff(location)
    this.props.setRiderLocationQuery('')
  }

  private swapStops = (index: number) => {
    const selectedStop = this.state.additionalStop.find(value => value.index === index)

    if (selectedStop !== undefined) {
      const draggedOverStop = {
        ...(this.state.draggedItem as ILocationStopV2),
        index
      }

      const draggedStopIndex = this.state.draggedItem !== null ? this.state.draggedItem.index : undefined

      const draggedOverStopIndex = index

      const filteredStops = this.state.additionalStop.filter(
        stop => stop.index !== (this.state.draggedItem !== null && this.state.draggedItem.index)
      )

      const filteredUpdatedStops = filteredStops.map(stop => {
        if (draggedStopIndex !== undefined) {
          if (draggedOverStopIndex < draggedStopIndex) {
            if (stop.index !== undefined && stop.index >= draggedOverStopIndex && stop.index < draggedStopIndex) {
              const newStop = {
                ...stop,
                index: stop.index + 1
              }

              return newStop
            }
          } else if (draggedOverStopIndex > draggedStopIndex) {
            if (stop.index !== undefined && stop.index <= draggedOverStopIndex && stop.index > draggedStopIndex) {
              const newStop = {
                ...stop,
                index: stop.index - 1
              }

              return newStop
            }
          }
        }
        return stop
      })

      const updatedStops = [...filteredUpdatedStops, draggedOverStop].sort(
        (a, b) => (a.index as number) - (b.index as number)
      )

      const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

      this.setState({
        additionalStopAutocompleteToShow: -1,
        additionalStop: updatedStops,
        additionalStopsIndeces: indeces as number[]
      })
      this.props.changeAdditionalStopOrder(draggedStopIndex as number, draggedOverStopIndex)
    }
  }

  private swapLocations = (index: number) => {
    const draggedStopIndex = this.state.draggedItem !== null ? this.state.draggedItem.index : undefined
    const additionalStops = this.props.additionalStop

    const draggedOverStopIndex = index

    let oldDraggedOverStop
    let oldDraggedStop

    if (draggedStopIndex === -1) {
      oldDraggedStop = this.props.pickup

      const newPickup: ILocationV2 = {
        ...additionalStops[0],
        coordinates: {
          type: 'Point',
          coordinates: [additionalStops[0].longitude, additionalStops[0].latitude]
        }
      }

      if (draggedOverStopIndex !== -2) {
        oldDraggedOverStop = additionalStops.find(value => value.index === draggedOverStopIndex)

        if (oldDraggedOverStop !== undefined) {
          const newDraggedOverStop: ILocationStopV2 = {
            ...oldDraggedStop,
            index: oldDraggedOverStop.index,
            coordinates: {
              longitude: oldDraggedStop.longitude,
              latitude: oldDraggedStop.latitude
            }
          }

          const filteredStops = this.props.additionalStop.filter((stop, index) => index !== 0)

          const filteredUpdatedStops = filteredStops.map(stop => {
            if (draggedStopIndex !== undefined) {
              if (stop.index !== undefined && stop.index <= draggedOverStopIndex) {
                const newStop = {
                  ...stop,
                  index: stop.index - 1
                }

                return newStop
              }
            }
            return stop
          })

          const updatedStops = [...filteredUpdatedStops, newDraggedOverStop].sort(
            (a, b) => (a.index as number) - (b.index as number)
          )

          const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

          this.setState({
            additionalStopAutocompleteToShow: -1,
            additionalStop: updatedStops,
            additionalStopsIndeces: indeces as number[],
            pickup: newPickup
          })
        }
      } else {
        const newDropOff: ILocationV2 = this.props.pickup
        const newLastElement: ILocationStopV2 = {
          ...this.props.dropoff,
          index: additionalStops[additionalStops.length - 1].index,
          coordinates: {
            longitude: this.props.dropoff.longitude,
            latitude: this.props.dropoff.latitude
          }
        }

        const filteredStops = this.state.additionalStop.filter((stop, index) => index !== 0)

        const filteredUpdatedStops = filteredStops.map(stop => {
          if (stop.index !== undefined) {
            const newStop = {
              ...stop,
              index: stop.index - 1
            }

            return newStop
          } else {
            return stop
          }
        })

        const updatedStops = [...filteredUpdatedStops, newLastElement].sort(
          (a, b) => (a.index as number) - (b.index as number)
        )

        const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

        this.setState({
          additionalStopAutocompleteToShow: -1,
          additionalStop: updatedStops,
          additionalStopsIndeces: indeces as number[],
          pickup: newPickup,
          dropoff: newDropOff
        })
      }
    } else if (draggedStopIndex === -2) {
      oldDraggedStop = this.props.dropoff

      const newDropOff: ILocationV2 = {
        ...additionalStops[additionalStops.length - 1],
        coordinates: {
          type: 'Point',
          coordinates: [
            additionalStops[additionalStops.length - 1].longitude,
            additionalStops[additionalStops.length - 1].latitude
          ]
        }
      }

      if (draggedOverStopIndex !== -1) {
        oldDraggedOverStop = additionalStops.find(value => value.index === draggedOverStopIndex)

        if (oldDraggedOverStop !== undefined) {
          const newDraggedOverStop: ILocationStopV2 = {
            ...oldDraggedStop,
            index: oldDraggedOverStop.index,
            coordinates: {
              longitude: oldDraggedStop.longitude,
              latitude: oldDraggedStop.latitude
            }
          }

          const filteredStops = this.props.additionalStop.filter(
            (stop, index) => index !== this.props.additionalStop.length - 1
          )

          const filteredUpdatedStops = filteredStops.map(stop => {
            if (draggedStopIndex !== undefined) {
              if (stop.index !== undefined && stop.index >= draggedOverStopIndex) {
                const newStop = {
                  ...stop,
                  index: stop.index + 1
                }

                return newStop
              }
            }
            return stop
          })

          const updatedStops = [...filteredUpdatedStops, newDraggedOverStop].sort(
            (a, b) => (a.index as number) - (b.index as number)
          )

          const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

          this.setState({
            additionalStopAutocompleteToShow: -1,
            additionalStop: updatedStops,
            additionalStopsIndeces: indeces as number[],
            dropoff: newDropOff
          })
        }
      } else {
        const newPickup: ILocationV2 = this.props.dropoff
        const newFirstElement: ILocationStopV2 = {
          ...this.props.pickup,
          index: additionalStops[0].index,
          coordinates: {
            longitude: this.props.pickup.longitude,
            latitude: this.props.pickup.latitude
          }
        }

        const filteredStops = this.state.additionalStop.filter(
          (stop, index) => index !== this.state.additionalStop.length - 1
        )

        const filteredUpdatedStops = filteredStops.map(stop => {
          if (stop.index !== undefined) {
            const newStop = {
              ...stop,
              index: stop.index + 1
            }

            return newStop
          } else {
            return stop
          }
        })

        const updatedStops = [...filteredUpdatedStops, newFirstElement].sort(
          (a, b) => (a.index as number) - (b.index as number)
        )

        const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

        this.setState({
          additionalStopAutocompleteToShow: -1,
          additionalStop: updatedStops,
          additionalStopsIndeces: indeces as number[],
          pickup: newPickup,
          dropoff: newDropOff
        })
      }
    } else {
      if (draggedOverStopIndex === -1) {
        oldDraggedStop = additionalStops.find(value => value.index === draggedStopIndex)

        const oldPickup = this.props.pickup

        if (oldDraggedStop !== undefined) {
          const newPickup: ILocationV2 = {
            ...oldDraggedStop,
            coordinates: {
              type: 'Point',
              coordinates: [oldDraggedStop.longitude, oldDraggedStop.latitude]
            }
          }

          const newFirstElement: ILocationStopV2 = {
            ...oldPickup,
            index: additionalStops[0].index,
            coordinates: {
              latitude: oldPickup.latitude,
              longitude: oldPickup.longitude
            }
          }

          const filteredStops = this.props.additionalStop.filter(stop => stop.index !== draggedStopIndex)

          const filteredUpdatedStops = filteredStops.map(stop => {
            if (draggedStopIndex !== undefined) {
              if (stop.index !== undefined && stop.index <= draggedStopIndex) {
                const newStop = {
                  ...stop,
                  index: stop.index + 1
                }

                return newStop
              }
            }
            return stop
          })

          const updatedStops = [...filteredUpdatedStops, newFirstElement].sort(
            (a, b) => (a.index as number) - (b.index as number)
          )

          const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

          this.setState({
            additionalStopAutocompleteToShow: -1,
            additionalStop: updatedStops,
            additionalStopsIndeces: indeces as number[],
            pickup: newPickup
          })
        }
      } else if (draggedOverStopIndex === -2) {
        oldDraggedStop = additionalStops.find(value => value.index === draggedStopIndex)

        const oldDropoff = this.props.dropoff

        if (oldDraggedStop !== undefined) {
          const newDropoff: ILocationV2 = {
            ...oldDraggedStop,
            coordinates: {
              type: 'Point',
              coordinates: [oldDraggedStop.longitude, oldDraggedStop.latitude]
            }
          }

          const newLastElement: ILocationStopV2 = {
            ...oldDropoff,
            index: additionalStops[additionalStops.length - 1].index,
            coordinates: {
              latitude: oldDropoff.latitude,
              longitude: oldDropoff.longitude
            }
          }

          const filteredStops = this.props.additionalStop.filter(stop => stop.index !== draggedStopIndex)

          const filteredUpdatedStops = filteredStops.map(stop => {
            if (draggedStopIndex !== undefined) {
              if (stop.index !== undefined && stop.index >= draggedStopIndex) {
                const newStop = {
                  ...stop,
                  index: stop.index - 1
                }

                return newStop
              }
            }
            return stop
          })

          const updatedStops = [...filteredUpdatedStops, newLastElement].sort(
            (a, b) => (a.index as number) - (b.index as number)
          )

          const indeces = updatedStops.filter(stop => stop.index !== undefined).map(stop => stop.index)

          this.setState({
            additionalStopAutocompleteToShow: -1,
            additionalStop: updatedStops,
            additionalStopsIndeces: indeces as number[],
            dropoff: newDropoff
          })
        }
      }
    }

    this.props.changeLocationsOrder(draggedStopIndex as number, draggedOverStopIndex)
  }

  private onSaveLocation = (location: IRiderLocationObject) => {
    const loc = {
      fullAddress: location.fullAddress,
      latitude: location.coordinates.lat,
      longitude: location.coordinates.lng,
      phoneNumber: location.phoneNumber
    }
    if (this.state.locationType === LocationTypes.PICKUP) {
      this.setState({
        pickup: loc
      })
      this.props.saveLocation(this.props.rider.id, location, SET_ORIGIN_TO_TRIP_REQUEST, this.props.locations)
    } else if (this.state.locationType === LocationTypes.DROPOFF) {
      this.setState({
        dropoff: loc
      })
      this.props.saveLocation(this.props.rider.id, location, SET_DESTINATION_TO_TRIP_REQUEST, this.props.locations)
    } else {
      const updatedStop = {
        ...loc,
        index: this.state.selectedAdditionalStopForPinLocation
      }
      const filteredStops = this.state.additionalStop.filter(
        stop => stop.index !== this.state.selectedAdditionalStopForPinLocation
      )
      const updatedStops = [...filteredStops, updatedStop].sort((a, b) => (a.index as number) - (b.index as number))

      this.setState({
        additionalStop: updatedStops
      })
      this.props.saveLocation(
        this.props.rider.id,
        location,
        SET_ADDITIONAL_STOP_TO_TRIP_REQUEST,
        this.props.locations,
        this.state.selectedAdditionalStopForPinLocation
      )
    }
  }

  private onCancel = () => {
    this.setState({
      isOpen: false
    })
  }

  private openPickUpModal = () => {
    this.openModal(LocationTypes.PICKUP)
  }

  private openDropOffModal = () => {
    this.openModal(LocationTypes.DROPOFF)
  }

  private openStopModal = (index: number) => {
    this.openAdditionalStopModal(LocationTypes.ADDITIONALSTOP, index)
  }

  private openModal = (locationType: string) => {
    const { pickup, dropoff } = this.props
    let location: any
    if (
      (locationType === LocationTypes.PICKUP && pickup.latitude === 0 && pickup.longitude === 0) ||
      (locationType === LocationTypes.DROPOFF && dropoff.latitude === 0 && dropoff.longitude === 0)
    ) {
      return
    }
    if (pickup && locationType === LocationTypes.PICKUP) {
      location = {
        ...pickup,
        isNew: true
      }
      this.setState({
        pickup: location
      })
    } else if (dropoff && locationType === LocationTypes.DROPOFF) {
      location = {
        ...dropoff,
        isNew: true
      }
      this.setState({
        dropoff: location
      })
    }
    this.setState({
      isOpen: true,
      locationType
    })
  }

  private openAdditionalStopModal = (locationType: string, index: number) => {
    const { additionalStop } = this.props

    const selectedStop = additionalStop.find(value => value.index === index)

    if (selectedStop !== undefined) {
      const updatedStop = {
        ...selectedStop,
        isNew: true
      }

      const filteredStops = this.state.additionalStop.filter(stop => stop.index !== index)
      const updatedStops = [...filteredStops, updatedStop].sort((a, b) => (a.index as number) - (b.index as number))

      this.setState({
        additionalStop: updatedStops
      })
    }
    this.setState({
      isOpen: true,
      locationType,
      selectedAdditionalStopForPinLocation: index
    })
  }

  private clickSwap = (e: any) => {
    const { pickup, dropoff } = this.props
    if (pickup.latitude && dropoff.latitude) {
      this.props.swapLocations({ pickup, dropoff })
    }
  }
}

export default LocationSearch



// WEBPACK FOOTER //
// ./src/components/trips/locations/LocationSearch.tsx